
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingItemsGrid extends Serenity.EntityGrid<TreeMakingItemsRow, any> {
        protected getColumnsKey() { return 'Production.TreeMakingItems'; }
        protected getDialogType() { return TreeMakingItemsDialog; }
        protected getIdProperty() { return TreeMakingItemsRow.idProperty; } 
        protected getLocalTextPrefix() { return TreeMakingItemsRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
        }
    }
}